export const createAccountPayload = (accountName: string) => ({
  name: accountName,
  tier: 0,
})
